export default __webpack_public_path__ + "static/media/crossGrey.1c61efaa.svg";